(function () {
  if (!window.swatchConfig || !window.swatchConfig.enable) return;

  const MAX_VISIBLE = 4;

  // Tracks product IDs that have already been processed so re-renders don't double-fetch
  const initialized = new Set();

  // Full product data keyed by handle (from /products/handle.js — has images[])
  // Pre-fetched eagerly so swatch clicks are synchronous with no fetch latency
  const productDetailCache = new Map();

  function hexToSwatchSrc(hex) {
    const color = hex ? (String(hex).startsWith('#') ? hex : '#' + hex) : 'transparent';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35"><rect width="35" height="35" fill="${color}"/></svg>`
    );
  }

  function toAbsolute(src) {
    return src ? (String(src).startsWith('//') ? 'https:' + src : String(src)) : '';
  }

  function getImageSrc(product) {
    const imageType = window.swatchConfig.image_type;
    if (imageType === 'swatch_hex') return hexToSwatchSrc(product.swatch_hex);

    if (imageType === 'swatch_image') {
      const imgVal = product.swatch_image;
      const colorVal = product.swatch_color_mf;
      const priority = window.swatchConfig.metafield_type || 'image';

      if (priority === 'color') {
        if (colorVal) return hexToSwatchSrc(String(colorVal));
        if (imgVal) return toAbsolute(imgVal);
      } else {
        if (imgVal) return toAbsolute(imgVal);
        if (colorVal) return hexToSwatchSrc(String(colorVal));
      }
      // both fields empty — fall through to featured_image
    }

    return toAbsolute(product.featured_image);
  }

  // Returns a Shopify CDN URL sized to NNNx (inserts _NNNx before the extension)
  function shopifyImgUrl(url, size) {
    if (!url) return '';
    const src = String(url).startsWith('//') ? 'https:' + url : url;
    return src.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, `_${size}x.$1$2`);
  }

  function buildSwatchHtml(products, currentHandle) {
    let html = '';
    const available = products.filter(p => p.available);
    const list = available.length ? available : products;

    list.forEach(product => {
      const imgSrc = getImageSrc(product);
      html += `<input
        swatch-input
        type="image"
        class="${currentHandle === product.handle ? 'current selected' : ''}"
        aria-label="${product.handle}"
        data-handle="${product.handle}"
        data-title="${String(product.title).replace(/"/g, '&quot;')}"
        data-available="${product.available}"
        data-swatch-type="${window.swatchConfig.type || 'square'}"
        src="${imgSrc}"
        data-href="${product.url || '/products/' + product.handle}"
      >`;
    });
    return html;
  }

  function applySwatches(containers, products, currentHandle) {
    const html = buildSwatchHtml(products, currentHandle);

    if (!html) {
      containers.forEach(container => {
        container.closest('.colour-swatches--collection')?.classList.add('swatch-empty--hide');
      });
      return;
    }

    containers.forEach(container => {
      container.innerHTML = html;
    });

    containers.forEach(container => {
      const allSwatches = [...container.querySelectorAll('[swatch-input]')];
      const selected = allSwatches.find(s => s.classList.contains('selected'));
      if (selected) container.prepend(selected);

      const visible = [...container.querySelectorAll('[swatch-input]')];
      if (visible.length > MAX_VISIBLE) {
        const overflow = visible.length - MAX_VISIBLE;
        visible.slice(MAX_VISIBLE).forEach(el => el.remove());
        const more = document.createElement('span');
        more.className = 'colour-swatches__more';
        more.textContent = `+${overflow}`;
        container.appendChild(more);
      }
    });
  }


  function updatePrice(card, product) {
    const priceWrapper = card.querySelector('.price');
    if (!priceWrapper || !Shopify?.formatMoney) return;

    const price = product.price;
    const compareAt = product.compare_at_price;
    const onSale = compareAt && compareAt > price;

    const formatted = Shopify.formatMoney(price);
    const formattedCompare = compareAt ? Shopify.formatMoney(compareAt) : null;

    priceWrapper.querySelectorAll('.price-item--regular').forEach(el => {
      el.textContent = onSale ? formattedCompare : formatted;
    });

    const saleEl = priceWrapper.querySelector('.price-item--sale');
    if (saleEl) saleEl.textContent = formatted;

    priceWrapper.classList.toggle('price--on-sale', !!onSale);
    priceWrapper.classList.toggle('price--sold-out', !product.available);
  }

  // Delegate swatch click handling — works for any card present or future
  document.addEventListener('click', async function (e) {
    const swatch = e.target.closest('[swatch-input]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const handle = swatch.dataset.handle;
    if (!handle) return;

    const card = swatch.closest('.grid__item');
    if (!card) return;

    const slider = card.querySelector('slider-component');
    const sliderList = slider?.querySelector('ul.slider');

    // Immediately suppress the secondary hover image via inline style so the
    // 0.4s CSS opacity transition on .media > img can't cause a visible flash
    const secondaryImg = card.querySelector('.card__inner .media > img');
    if (secondaryImg) secondaryImg.style.opacity = '0';

    // Remove hover class and reset slider position
    if (slider) slider.classList.remove('slider-component__slider--hover');
    if (sliderList) sliderList.scrollLeft = 0;

    function restoreSecondaryImg() {
      // Restore after one paint cycle — slider is on top (z-index:2) so secondary
      // img fading back in is invisible to the user
      requestAnimationFrame(() => {
        if (secondaryImg) secondaryImg.style.removeProperty('opacity');
      });
    }

    function applyProduct(product) {
      if (sliderList && product.images?.length) {
        // Swap only the first slide's image — avoids ResizeObserver/DOM-insertion
        // side-effects that a full innerHTML rebuild triggers (which caused a flash of slide 2)
        const firstImg = sliderList.querySelector('li:first-child img');
        if (firstImg) {
          const src = String(product.images[0]);
          firstImg.removeAttribute('srcset');
          firstImg.src = src.startsWith('//') ? 'https:' + src : src;
          firstImg.loading = 'eager';
        }
        sliderList.scrollLeft = 0;
      } else if (product.featured_image) {
        const primaryImg = card.querySelector('.card__inner img.motion-reduce');
        if (primaryImg) {
          primaryImg.removeAttribute('srcset');
          primaryImg.src = shopifyImgUrl(product.featured_image, 533);
        }
      }

      card.querySelectorAll('[swatch-input]').forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');

      const newUrl = swatch.dataset.href || `/products/${handle}`;
      card.querySelectorAll('a.card, a.full-unstyled-link').forEach(link => {
        link.href = newUrl;
      });

      const titleEl = card.querySelector('.card-information__text.p-large a');
      if (titleEl) {
        titleEl.textContent = swatch.dataset.title || product.title;
        titleEl.href = newUrl;
      }

      updatePrice(card, product);
    }

    // Use pre-fetched detail data for a synchronous swap
    if (productDetailCache.has(handle)) {
      applyProduct(productDetailCache.get(handle));
      restoreSecondaryImg();
      return;
    }

    // Fallback: fetch on demand (first click if pre-fetch hasn't completed yet)
    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      productDetailCache.set(product.handle, product);
      applyProduct(product);
      restoreSecondaryImg();
    } catch (err) {
      if (secondaryImg) secondaryImg.style.removeProperty('opacity');
      console.warn('Colour swatches: image swap failed', err);
    }
  }, true);

  // Fetch and apply swatches for a set of card elements, skipping already-processed ones
  function processCards(cards) {
    const fresh = [...cards].filter(card => {
      const id = card.dataset.productId;
      if (!id || initialized.has(id)) return false;
      initialized.add(id);
      return true;
    });

    if (!fresh.length) return;

    const groups = {};
    fresh.forEach(card => {
      const groupTag = card.dataset.groupTag;
      if (!groupTag) return;
      if (!groups[groupTag]) groups[groupTag] = [];
      groups[groupTag].push(card);
    });

    Object.entries(groups).forEach(([groupTag, groupCards]) => {
      fetch(`/collections/all/${encodeURIComponent(groupTag)}?view=data`)
        .then(r => r.json())
        .then(products => {
          if (!Array.isArray(products) || !products.length) return;
          groupCards.forEach(card => {
            const containers = document.querySelectorAll(`#swatches-${card.dataset.productId}`);
            if (!containers.length) return;
            applySwatches(containers, products, card.dataset.productHandle);
          });
          // Pre-fetch full product detail in background so swatch clicks are instant
          products.forEach(p => {
            if (productDetailCache.has(p.handle)) return;
            fetch(`/products/${p.handle}.js`)
              .then(r => r.json())
              .then(data => productDetailCache.set(data.handle, data))
              .catch(() => { });
          });
        })
        .catch(err => console.warn('Colour swatches: fetch failed for', groupTag, err));
    });
  }

  function init() {
    processCards(document.querySelectorAll('.card-wrapper[data-group-tag]'));
  }

  // Single observer on ProductGridContainer covers both:
  //   - Filter/sort: facets.js replaces ProductGridContainer.innerHTML entirely
  //   - Load More: load-more.js appends li.grid__item directly to #product-grid
  function observeGrid() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    new MutationObserver(mutations => {
      const newCards = [];
      let fullReplace = false;

      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          // A node containing #product-grid means the whole grid was swapped (filter/sort)
          if (node.querySelector && node.querySelector('#product-grid')) {
            fullReplace = true;
          }
          newCards.push(...node.querySelectorAll('.card-wrapper[data-group-tag]'));
        });
      });

      if (fullReplace) {
        // Clear so cards that appear again after filtering get fresh swatches and data
        initialized.clear();
        productDetailCache.clear();
      }

      if (newCards.length) processCards(newCards);
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); observeGrid(); });
  } else {
    init();
    observeGrid();
  }
})();
